import { MODAL_KEYS } from '../../utils/const'

const state = {
    modals: {
        [MODAL_KEYS.DEBUGGER_INSPECT]: {
            open: false
        }
    },
    modalStack: []
}
const mutations = {}
const actions = {
    closeModal ({ state }, name) {
        state.modals[name] = {
            ...state.modals[name],
            open: false
        }
        state.modalStack = state.modalStack.filter(openModalName => name !== openModalName)
    },
    closeAllModal ({ state }) {
        Object.keys(state.modals).forEach((name) => {
            if (state.modals[name].open) {
                state.modals[name] = {
                    ...state.modals[name],
                    open: false
                }
            }
        })
        state.modalStack = []
    },
    setModalData ({ state }, { name, data }) {
        state.modals[name] = {
            ...state.modals[name],
            data: data
        }
    },
    openModal ({ state }, name) {
        state.modals[name] = {
            ...state.modals[name],
            open: true
        }
    },
    openModalWithData ({ dispatch }, { name, data }) {
        dispatch('setModalData', { name, data })
        dispatch('openModal', name)
    }
}
const getters = {
    isModalActive (state) {
        return (name) => state.modalStack.length > 0 && name === state.modalStack[0]
    },
    isModalOpen (state) {
        return (name) => state.modals[name].open
    },
    getActiveModalId (state) {
        return (name) => state.modals[name].activeId
    },
    getModalData (state) {
        return (name) => state.modals[name].data
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
